import {Endpoints} from "../Endpoints";
import Backend from "../../Backend";

export default class InternalShoppingCart {
    constructor(token) {
        this.backend = new Backend(token);
    }

    getShoppingCart(purchaseSourceId, callback) {
        this.backend.callBackend(`${Endpoints.shoppingCart.internal}/${purchaseSourceId}`,
            callback, "GET");
    }

    addGiftCardToShoppingCart(giftCardTypeId, amount, quantity, variable,referenceValue, callback) {
               let body = {
            giftCardTypeId: giftCardTypeId,
            quantity: quantity,
            orderReference:referenceValue
            
        }
                if (!variable) {
            body.amount = amount
        }
        this.backend.callBackend(`${Endpoints.shoppingCart.internal}/add`,
            callback,
            'POST',
            body);
    }

    purchaseShoppingCart(name,referenceValue, callback) {
        this.backend.callBackend(`${Endpoints.shoppingCart.internal}/purchase-order`,
            callback,
            'POST',
            {
                name,
               "orderReference": referenceValue,
              
            });
    }

    updateItemQuantity(cartItemId, qty, callback) {
        this.backend.callBackend(`${Endpoints.shoppingCart.internal}/update/cart-item/${cartItemId}/quantity/${qty}`,
            callback,
            "PUT");
    }

    deleteItem(cartItemId, callback) {
        this.backend.callBackend(`${Endpoints.shoppingCart.internal}/delete/${cartItemId}`,
            callback,
            "DELETE");
    }
}